module.exports = __webpack_public_path__ + "img/logo-astana-hub.95482e06.png";